import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const REVEAL_SELECTOR = "main section, main article, footer";

export default function ScrollRevealController() {
  const location = useLocation();

  useEffect(() => {
    const observedElements = new Set();
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const reveal = (element) => {
      element.classList.add("is-visible");
    };

    const observer =
      !prefersReducedMotion && "IntersectionObserver" in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                reveal(entry.target);
                observer.unobserve(entry.target);
                observedElements.delete(entry.target);
              });
            },
            {
              threshold: 0.01,
              rootMargin: "0px 0px 18% 0px",
            }
          )
        : null;

    const register = (element) => {
      if (!(element instanceof HTMLElement)) return;
      element.classList.add("site-scroll-reveal");

      if (element.classList.contains("is-visible")) return;

      if (!observer || element.getBoundingClientRect().top < window.innerHeight * 0.92) {
        reveal(element);
        return;
      }

      if (observedElements.has(element)) return;

      observedElements.add(element);
      observer.observe(element);
    };

    const scanPage = () => {
      document.querySelectorAll(REVEAL_SELECTOR).forEach(register);
    };

    const animationFrame = window.requestAnimationFrame(scanPage);
    const mutationObserver = new MutationObserver(scanPage);
    const pageRoot = document.querySelector("main") || document.body;

    mutationObserver.observe(pageRoot, { childList: true, subtree: true });

    return () => {
      window.cancelAnimationFrame(animationFrame);
      mutationObserver.disconnect();
      observer?.disconnect();
      observedElements.clear();
    };
  }, [location.pathname]);

  return null;
}
